import React from 'react'
import { FileText } from 'lucide-react'
import { type NodeProps } from '@xyflow/react'
import { BaseNode } from './Base/BaseNode'
import type { InformationFlowNode } from '../../../types/mindmap-components'

/**
 * Information node component - basic text node for general information
 * Information nodes cannot create or attach to child nodes - they are leaf nodes only
 */
export const InformationNode = React.memo((props: NodeProps<InformationFlowNode>) => {
  const nodeData = props.data
  return (
    <BaseNode
      id={props.id}
      nodeData={nodeData}
      icon={FileText}
      categoryLabel="Information"
      categoryDescription="General notes and information. Use this for documenting context, research, or any supporting details."
      hideSourceHandle={true}
    />
  )
})
